export default {
  // ljy语言配置
  Each_SKU_storage_fee_calculation_starts_from_the_batch_entry_date:
    "每个SKU入库批次开始计算仓租天数",
  Dispatch_return_items: "下发退件",
  Only_save_the_hour_minute_and_second_of_the_confirmation_time:
    "仅保存确认时间的时分秒",
  When_conducting_a_quick_search: "快捷查询时",
  the_default_end_date_is_set_to_today_date: "默认结束日期为今日日期",
  Query_the_start_date_based_on_the_saved_time_period_in_real_time:
    "根据保存的时间段实时查询开始日期",
  Today_delivery: "今日达",
  Nextday_delivery: "次日达",
  Today_delivery_Platform: "平台今日达",
  Today_delivery_Shopee: "Shopee今日达",
  Nextday_delivery_Shopee: "Shopee次日达",
  Today_delivery_Lazada: "Lazada今日达",
  Nextday_delivery_Lazada: "Lazada次日达",
  Today_delivery_Tiktok: "Tiktok今日达",
  Nextday_delivery_Tiktok: "Tiktok次日达",
  Today_delivery_Temu: "Temu今日达",
  Nextday_delivery_Temu: "Temu次日达",
  You_cannot_choose_both_today_and_next_day_delivery:
    "不能同时选择今日达与次日达",
};
